<nav class="main-navbar navbar navbar-expand-lg navbar-inverse container-fluid bg-inverse d-flex justify-content-between">
    <div class="navbar-header">
        <a (click)="goToHome()" *ngIf="!hideUptopLogo">
          <picture>
            <source srcset="/assets/img/logo_uefa-uptop_@2x.png">
            <img src="/assets/img/logo_uefa@2x.png" class="logo">
          </picture>
        </a>
    </div>

    <div class="d-flex align-items-center" *ngIf='!errorMessage'>
        <div class="nav-item me-3" *ngIf='!hideCompetitonSelector' [class.hide]="isExpanded">
          <app-dropdown-menu [options]="options" [selected]="selected" (select)="onSelectCompetition($event)"></app-dropdown-menu>
        </div>
        <div class="nav-item me-3" routerLinkActive="active">
            <a class="nav-link" [routerLink]="" (click)="openGuide()">
              <span><i class="icon icon-questions" aria-hidden="true"></i></span>
            </a>
        </div>
        <div class="nav-item me-3 user-menu" *ngIf='!hideUser'>
          <app-dropdown-menu [iconName]="'icon-user'" [options]="userOptions" (select)="onSelectUserOption($event)"></app-dropdown-menu>
        </div>
        <div class="nav-item content-menu" *ngIf="isAdminUser">
          <app-dropdown-menu [iconName]="'icon-menu'" [options]="contentOptions" (select)="onSelectContentOption($event)"></app-dropdown-menu>
        </div>
    </div>
  </nav>
